import { render, staticRenderFns } from "./RelaisTable.vue?vue&type=template&id=7fd8e060&scoped=true&"
import script from "./RelaisTable.vue?vue&type=script&lang=js&"
export * from "./RelaisTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd8e060",
  null
  
)

export default component.exports